import { render, staticRenderFns } from "./PermissionItem.vue?vue&type=template&id=428f8a60&scoped=true"
import script from "./PermissionItem.vue?vue&type=script&lang=js"
export * from "./PermissionItem.vue?vue&type=script&lang=js"
import style0 from "./PermissionItem.vue?vue&type=style&index=0&id=428f8a60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428f8a60",
  null
  
)

export default component.exports